import React from 'react';
import {
  Badge, Button, ListGroup, Row, Col,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ProcessExcelResult } from 'utils/processExcelTemplate';

type Step4LogsProps = {
  processLogs: ProcessExcelResult | null,
  onRestart: () => void,
  onNext: () => void,
  operationTypeLabel?: string,
  promotionName?: string,
};

function Step4Logs( {
  processLogs,
  onRestart,
  onNext,
  operationTypeLabel,
  promotionName,
}: Step4LogsProps ) {
  const { t } = useTranslation();
  const hasErrors = processLogs?.hasErrors ?? false;

  return (
    <>
      {( operationTypeLabel || promotionName ) && (
        <Row className="mb-3 text--sm g-2">
          {operationTypeLabel && (
            <Col xs={12} md={6}>
              <span className="text-muted">{t( 'admin.processes.operationType' )}</span>
              <div className="fw-medium">{operationTypeLabel}</div>
            </Col>
          )}
          {promotionName && (
            <Col xs={12} md={6}>
              <span className="text-muted">{t( 'admin.processes.promotion' )}</span>
              <div className="fw-medium">{promotionName}</div>
            </Col>
          )}
        </Row>
      )}
      {processLogs?.rowLogs?.length ? (
        <ListGroup className="mb-4">
          {processLogs.rowLogs.map( ( log ) => (
            <ListGroup.Item
              key={`row-${log.rowIndex}-${log.accountName}`}
              variant={log.success ? undefined : 'danger'}
              className={log.success ? '' : 'bg-opacity-10'}
            >
              <div className="d-flex justify-content-between align-items-start">
                <span className="fw-medium">{log.accountName}</span>
                <Badge bg={log.success ? 'success' : 'danger'} className="ms-2">
                  {log.success ? 'success' : 'error'}
                </Badge>
              </div>
              {log.errors.length > 0 && (
                <ListGroup variant="flush" className="mt-2 small">
                  {log.errors.map( ( msg ) => (
                    <ListGroup.Item
                      key={msg}
                      variant="danger"
                      className="py-1 ps-0 bg-transparent border-0"
                    >
                      {msg}
                    </ListGroup.Item>
                  ) )}
                </ListGroup>
              )}
            </ListGroup.Item>
          ) )}
        </ListGroup>
      ) : (
        <p className="text-muted">{t( 'admin.processes.logsPlaceholder' )}</p>
      )}
      <Button
        variant="primary"
        className="btn--full-width mt-4"
        onClick={hasErrors ? onRestart : onNext}
      >
        {hasErrors ? t( 'admin.processes.restart' ) : t( 'admin.processes.next' )}
      </Button>
    </>
  );
}

export default Step4Logs;
